interface StepComponentProps {
  title: string | null;
  StepContent: any;
  visible: boolean;
}

const StepContainer: React.FC<StepComponentProps> = ({
  title,
  StepContent,
  visible,
}) => {
  return (
    <div className="step-container">
      <h2 className="title-step">{title}</h2>
      {StepContent(visible)}
    </div>
  );
};

export default StepContainer;
